module.exports = __webpack_public_path__ + "img/OpaOslo.5cddf789.svg";